import { useRef, useState } from "react";
import { ChevronRight, Check, Loader2 } from "lucide-react";

export const SlideToComplete = ({ label, releaseLabel, busyLabel, doneLabel, onComplete, disabled, done, busy }) => {
  const track = useRef(null);
  const [x, setX] = useState(0);
  const dragging = useRef(false);
  const [, force] = useState(0);
  const HANDLE = 56;

  const maxX = () => (track.current ? track.current.clientWidth - HANDLE - 8 : 1);
  const pct = x / Math.max(maxX(), 1);

  const move = (clientX) => {
    if (!dragging.current || disabled || done || busy) return;
    const rect = track.current.getBoundingClientRect();
    setX(Math.max(0, Math.min(maxX(), clientX - rect.left - HANDLE / 2)));
  };
  const end = () => {
    if (!dragging.current) return;
    dragging.current = false; force((n) => n + 1);
    if (pct >= 0.9) { navigator.vibrate?.(50); setX(maxX()); onComplete(); } else setX(0);
  };
  const begin = (e) => { e.currentTarget.setPointerCapture(e.pointerId); dragging.current = true; force((n) => n + 1); };

  return (
    <div ref={track} className={`slider ${done ? "slider-done" : ""} ${disabled ? "slider-disabled" : ""}`} data-testid="slide-to-complete" data-progress={Math.round(pct * 100)}
      onPointerMove={(e) => move(e.clientX)} onPointerUp={end} onPointerLeave={end} onPointerCancel={end}>
      <div className="slider-fill" style={{ width: `${Math.max(0, x + HANDLE)}px` }} />
      <span className="slider-label" data-testid="slide-label">{done ? doneLabel : busy ? busyLabel : pct >= 0.9 ? releaseLabel : label}</span>
      <button type="button" className="slider-handle" style={{ transform: `translateX(${done ? maxX() : x}px)` }} disabled={disabled || done || busy} data-testid="slide-handle"
        onPointerDown={begin}
        aria-label={label}>
        {done ? <Check size={24} strokeWidth={3} /> : busy ? <Loader2 className="animate-spin" size={22} /> : <ChevronRight size={26} strokeWidth={3} />}
      </button>
    </div>
  );
};
